var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00b197"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m32 64c17.6731 0 32-14.3269 32-32s-14.3269-32-32-32-32 14.3269-32 32 14.3269 32 32 32zm0-13.25c10.3553 0 18.75-8.3947 18.75-18.75s-8.3947-18.75-18.75-18.75-18.75 8.3947-18.75 18.75 8.3947 18.75 18.75 18.75z",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.667 32.0001c0-11.776 9.5573-21.3334 21.3333-21.3334s21.3334 9.5574 21.3334 21.3334-9.5574 21.3333-21.3334 21.3333-21.3333-9.5573-21.3333-21.3333zm2.6667 0c0 10.29 8.3766 18.6666 18.6666 18.6666s18.6667-8.3766 18.6667-18.6666-8.3767-18.6667-18.6667-18.6667-18.6666 8.3767-18.6666 18.6667z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.6621 25.3939-11.2079 11.2575-5.1025-5.1225c-.5387-.5413-1.409-.5413-1.9477 0-.5387.5414-.5387 1.4158 0 1.9572l6.0833 6.1079c.5387.5413 1.4089.5413 1.9476 0l12.1611-12.2291c.5387-.5414.5387-1.4158 0-1.9572-.5249-.5413-1.409-.5413-1.9339-.0138z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.9f30b761.svg";
export { ForwardRef as ReactComponent };